var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.59707,
    cy: 3.29098,
    r: 2.89383,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37159 5.87482V5.87482C7.62421 7.03422 9.55816 7.03422 10.8108 5.87482V5.87482V5.87482C13.124 6.82256 14.6349 9.07443 14.6349 11.5742V15.156V15.156C10.8603 16.7766 6.5926 16.8113 2.7922 15.2522L2.55786 15.156V11.5646C2.55786 9.0702 4.06428 6.82273 6.37159 5.87482V5.87482Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.e912ca0a5fd7de8dab0b097ac8a8d7b1.svg";
export { ForwardRef as ReactComponent };